import { FormControl, FormLabel, Select, MenuItem, InputLabel, Typography } from '@mui/material';
import { Controller } from "react-hook-form";

export default function Dropdown({name, control, errors, question, options, label, required}) {

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={''}
      render={({ field: { onChange, value } }) => 
      <FormControl fullWidth  error={errors? true : false}>
        <FormLabel required={required}>{question}</FormLabel>
        <FormControl variant='standard'>
          <InputLabel>{label}</InputLabel>
          <Select
            value={value}
            onChange={onChange}
          >
              {options.map(option => (<MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
          </Select>
          <Typography className="font-14 error-message">
            {errors?.message}
          </Typography>
        </FormControl>
      </FormControl>
      }
      />
  );
}